import type { Exhibit as ExhibitType, HeaderVariant } from "@/lib/api";
import { ExhibitHeader } from "./ExhibitHeader";
import { DisplayPiece } from "./DisplayPiece";
import {
  ExpandingLinesHeader,
  GrowingCircleHeader,
  OrganicStrokesHeader,
  MinimalLinesHeader,
  ElegantFrameHeader,
} from "./headers";

interface ExhibitProps {
  exhibit: ExhibitType;
}

interface HeaderProps {
  title?: string | null;
  description?: string | null;
}

const HEADER_COMPONENTS: Record<HeaderVariant, React.ComponentType<HeaderProps>> = {
  default: ExhibitHeader,
  "expanding-lines": ExpandingLinesHeader,
  "growing-circle": GrowingCircleHeader,
  "organic-strokes": OrganicStrokesHeader,
  "minimal-lines": MinimalLinesHeader,
  "elegant-frame": ElegantFrameHeader,
};

/**
 * Main exhibit container component
 * Composes the exhibit header and list of display pieces
 * Gallery exhibits skip the header (quick upload area)
 */
export function Exhibit({ exhibit }: ExhibitProps) {
  const HeaderComponent = HEADER_COMPONENTS[exhibit.headerVariant] || ExhibitHeader;

  // Skip rendering if no images
  if (exhibit.images.length === 0) {
    return null;
  }

  return (
    <article>
      {/* Gallery exhibits don't show a header */}
      {!exhibit.isGallery && (
        <HeaderComponent title={exhibit.title} description={exhibit.description} />
      )}

      {exhibit.images.map((image) => (
        <DisplayPiece key={image.id} image={image} />
      ))}
    </article>
  );
}
